import { render, staticRenderFns } from "./Subcard.vue?vue&type=template&id=4bb7e99f&functional=true&"
import script from "./Subcard.vue?vue&type=script&lang=js&"
export * from "./Subcard.vue?vue&type=script&lang=js&"
import style0 from "./Subcard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports